import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, filter, withLatestFrom } from 'rxjs/operators';
import AppState from '../../../state';
import { UpdateMerchProductError } from '@webapp/store/merch/action-creators';
import { UPDATE_MERCH_PRODUCT_ERROR } from '@webapp/store/merch/actions';

export const updateMerchProductError = (
  action$: Observable<UpdateMerchProductError>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType(UPDATE_MERCH_PRODUCT_ERROR),
    withLatestFrom(state$),
    map(([action, state]) => {
      if (window.analytics) {
        window.analytics.track('Merch Product Error', {
          product_id: state.merch.active?.newProduct?.productId,
          variant_id: state.merch.active?.editProduct?.variants,
          field_name: action.field,
          field_value: action.value,
          error: action.error,
        });
      }
    }),
    filter(() => false)
  );
